import React, { Component, Fragment } from 'react'
import PageLayout from './PageLayout'
import Helmet from 'react-helmet'
import Breadcrumb from '../common/Breadcrumb'
import AccordeonComponent from '../common/AccordeonItem'
import classNames from 'classnames'
import map from 'lodash/map'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import orderBy from 'lodash/orderBy'
import { pagesGroupChildTypes, buildURL } from '../../utils/url'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import richTextReactRendering from '../../utils/richTextReactRendering'
import SectionWidget from '../widgets/SectionWidget'
import VideoBackgroundWidget from '../widgets/VideoBackgroundWidget'

export default class GroupPageLayout extends Component {
    constructor(props) {
        super(props)

        const {
            page__generic: genericPages,
            page__widgets: widgetsPages,
            page__group: groupPages,
            pagegenericptp: genericPagesPTP, 
            pagewidgetsptp: widgetsPagesPTP, 
            pagegroupptp: groupPagesPTP, 
            orderOption, 
            groups: parentGroupPage 
        } = props.group
        if (parentGroupPage && groupPages) {
            const index = groupPages.findIndex((groupPage) => groupPage.slug === parentGroupPage.slug)
            groupPages.splice(index, 1)
        }
        let pages = [
            ...[...(genericPages || []), ...(widgetsPages || []), ...(groupPages || []), ...(genericPagesPTP || []), ...(widgetsPagesPTP || []), ...(groupPagesPTP || [])].map((page) => ({
                ...page,
                url: buildURL(page, pagesGroupChildTypes[page.__typename]),
            })),
        ]

        pages = Array.from(pages.reduce((map, page) => map.set(page.slug, page), new Map()).values())

        if (orderOption === 'Chronological') {
            this.state = {
                pages: orderBy(pages, ['createdAt'], ['desc']),
            }
        } else if (orderOption === 'Manual') {
            this.state = {
                pages: !props.preview
                    ? props.group.orderedList &&
                      props.group.orderedList.map((page) => ({
                          ...page,
                          url: buildURL(page, pagesGroupChildTypes[page.__typename]),
                      }))
                    : this.orderContentManuallyPreview(pages),
            }
        } else {
            this.state = {
                pages: sortBy(pages, 'title'),
            }
        }
    }

    orderContentManuallyPreview(pages) {
        const { group } = this.props
        if (group.orderedList && group.orderedList !== null) {
            let orderedGenericPages = []
            for (let i = 0; i < group.orderedList.length; i++) {
                if (group.orderedList[i] && group.orderedList[i].fields) {
                    const page = pages.find((p) => p.slug === group.orderedList[i].fields.slug)
                    if (page) orderedGenericPages.push(page)
                }
            }
            return orderedGenericPages
        } else {
            return pages
        }
    }

    renderMedia(backgroundVideoUrl, isIE11) {
        if (isIE11) {
            return this.renderImage()
        }
        return this.selectRenderMedia(backgroundVideoUrl)
    }

    selectRenderMedia(backgroundVideoUrl) {
        if (backgroundVideoUrl) {
            return this.renderVideo()
        }
        return this.renderImage()
    }

    renderImage() {
        const { group } = this.props
        const backgroundImage = get(group, 'headerImage.file.url') || get(group, 'image.file.url') || ''
        const backgroundImageTitle = get(group, 'headerImage.title') || get(group, 'image.title') || ''
        const backgroundStyle = `linear-gradient(rgba(0,0,0,0) 30%, rgba(0,0,0,0.35) 100%), url(${backgroundImage})`
        const groupSummary = get(group, 'summary.summary')

        return (
            <div className="section-headline" role="img" aria-label={backgroundImageTitle} style={{ backgroundImage: backgroundStyle }}>
                <div className="main flex-column">
                    <div className="translucient">
                        <h1>{group.title}</h1>
                        {!!groupSummary && <p className="summary">{groupSummary}</p>}
                    </div>
                </div>
            </div>
        )
    }

    renderVideo() {
        const { group } = this.props
        const groupSummary = get(group, 'summary.summary')
        const backgroundVideoUrl = get(group, 'headerVideo', '')
        const fullWidth = get(group, 'headerImageFullWidth')
        return (
            <div className={fullWidth === true || typeof fullWidth === 'undefined' ? 'group-hero' : 'group-hero no-full-width'}>
                <VideoBackgroundWidget url={backgroundVideoUrl} />
                <div className="main flex-column">
                    <div className="hero-text translucient">
                        <h1>{group.title}</h1>
                        {!!groupSummary && <p className="summary">{groupSummary}</p>}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { group, preview, sitemap, className } = this.props
        const backgroundImage = get(group, 'headerImage.file.url') || get(group, 'image.file.url') || ''
        const hasImage = !!backgroundImage
        const backgroundVideoUrl = get(group, 'headerVideo', '')
        const groupSummary = get(group, 'summary.summary')
        const groupMetaDescription = get(group, 'metaDescription.metaDescription')
        const activeSection = group && group.userSection
        const body = preview ? group.body : group.body && JSON.parse(group.body.childContentfulRichText.internal.content)
        const sections = get(group, 'sections', [])
        const _window = typeof window !== 'undefined' && window
        const isIE11 = !!_window.MSInputMethodContext && !!document.documentMode
        return (
            <PageLayout className={classNames( { 'has-image': hasImage }, className ,'pages-group-index') } activeSection={activeSection} sitemap={sitemap}>
                {group && (
                    <Fragment>
                        <Helmet>
                            <title>{group.title}</title>
                            {(!!groupMetaDescription || !!groupSummary) && <meta name="description" content={groupMetaDescription || groupSummary} />}
                        </Helmet>
                        {this.renderMedia(backgroundVideoUrl, isIE11)}
                        <Breadcrumb page={group} params={this.props.location?.state?.params} paramsGroup={group.slug} />
                        <main className="main full-page wrapper flex-column">
                            <div className="richtext-body">{body && documentToReactComponents(body, richTextReactRendering)}</div>
                            {map(this.state.pages, (page) => {
                                const pageSummary = get(page, 'summary.summary')
                                return <AccordeonComponent breadParams={group.slug} key={page.slug} id={page.slug} title={page.title} content={pageSummary} url={page.url} linkName={page.goToPage} />
                            })}
                        </main>
                        <div className={'widgets-group-page'}>
                            <main className="wrapper flex-column container-fluid">
                                {map(sections, (section) => {
                                    return (
                                        <section className={`section row ${section.fullWidth ? '' : 'narrow'}`} key={section.name}>
                                            {map(section.widgets, (widget, index) => widget && <SectionWidget key={widget?.contentful_id || index} widget={widget} activeSection={activeSection} />)}
                                        </section>
                                    )
                                })}
                            </main>
                        </div>
                    </Fragment>
                )}
            </PageLayout>
        )
    }
}
